if (!customElements.get("fabric-details")) {
  class FabricDetails extends HTMLElement {
    constructor() {
      super();

      this.content = this.querySelector("[data-content]");
      this.activeHandle = null;

      document.addEventListener(
        "click",
        (event) => {
          this.handleTriggerClick(event);
        },
        true,
      );
    }

    handleTriggerClick(event) {
      const target = event.target instanceof Element ? event.target : null;
      const trigger = target && target.closest(
        '[aria-controls="drawer-fabric-details"][data-handle]',
      );

      if (!trigger || !this.isTriggerForThisDrawer(trigger)) return;

      const handle = trigger.dataset.handle;
      if (!handle) return;

      event.preventDefault();
      event.stopPropagation();

      this.loadDetails(handle, trigger);
      window.dispatchEvent(
        new CustomEvent("drawerOpen", {
          detail: { id: trigger.getAttribute("aria-controls") },
        }),
      );
    }

    isTriggerForThisDrawer(trigger) {
      const drawer = document.getElementById(trigger.getAttribute("aria-controls"));

      return drawer && drawer.contains(this);
    }

    loadDetails(handle, trigger) {
      if (!this.content) return;

      this.activeHandle = handle;
      this.content.innerHTML = "";
      this.classList.add("loading");

      if (this.renderEmbeddedTemplate(handle, trigger)) return;

      this.fetchDetails(handle);
    }

    renderEmbeddedTemplate(handle, trigger) {
      const scopedTemplate = trigger
        .closest(".fabrics__item")
        ?.querySelector("[data-fabric-details-template]");
      const template =
        scopedTemplate && scopedTemplate.dataset.fabricDetailsTemplate === handle
          ? scopedTemplate
          : [...document.querySelectorAll("[data-fabric-details-template]")].find(
              (item) => item.dataset.fabricDetailsTemplate === handle,
            );

      if (!template) return false;

      this.content.innerHTML = template.innerHTML;
      this.playVideos();
      this.classList.remove("loading");
      this.resizeDrawer();

      return true;
    }

    fetchDetails(handle) {
      fetch(`/pages/fabrics/${handle}?view=details`, { method: "GET" })
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          return response.text();
        })
        .then((html) => {
          if (this.activeHandle !== handle) return;

          const parsed = new DOMParser().parseFromString(html, "text/html");
          const content = parsed.querySelector("[data-content]");

          this.content.innerHTML = content ? content.innerHTML : "";
          this.playVideos();
          this.classList.remove("loading");
          this.resizeDrawer();
        })
        .catch((error) => {
          if (this.activeHandle !== handle) return;

          this.classList.remove("loading");
          console.error("Error loading fabric details:", error);
        });
    }

    playVideos() {
      this.content.querySelectorAll("video").forEach((video) => {
        video.muted = true;
        video.play().catch(() => {});
      });
    }

    resizeDrawer() {
      const drawer = this.closest("drawer-section");
      if (!drawer) return;

      drawer.dispatchEvent(new CustomEvent("drawerResize"));
      window.dispatchEvent(new CustomEvent("drawerResize"));
    }
  }

  customElements.define("fabric-details", FabricDetails);
}
